// Access the global JavaScript variable set in the Liquid template
var add_to_cart_text1 = window.add_to_cart_btn_text1;
console.log("Add " + add_to_cart_text1);
var add_to_cart_text2 = window.add_to_cart_btn_text2;
var add_to_cart_text3 = window.add_to_cart_btn_text3;

let totalItems = 0;
let totalPrice = 0;

function toggleDetails(element) {
  const details = element.nextElementSibling;
  if (details.style.display === "block") {
    details.style.display = "none";
  } else {
    details.style.display = "block";
  }
}

function formatCurrency(amount) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: Shopify.currency.active }).format(amount);
}

function updateCart(checkbox, price, discount_to_apply) {
  const button = document.getElementById("selected-goes-well-cart-button");
  const productDiv = checkbox.closest(".new-product");
  if (checkbox.checked) {
    totalItems += 1;
    totalPrice += price;
    productDiv.classList.add("highlight");
  } else {
    totalItems -= 1;
    totalPrice -= price;
    productDiv.classList.remove("highlight");
  }
  if (totalItems > 0) {
    const formattedPrice = formatCurrency(totalPrice / 100);
    let totalString = `${add_to_cart_text1} ${totalItems} ${add_to_cart_text2}${
      totalItems > 1 ? "" : ""
    } ${add_to_cart_text3}`;
    // let totalString = `Add ${totalItems} item${totalItems > 1 ? "s" : ""} to cart - ${formattedPrice}`;

    if (totalItems >= 3) {
      const discountedPrice = totalPrice * (1 - discount_to_apply / 100);
      const formattedDiscountedPrice = formatCurrency(discountedPrice / 100);
      totalString = `${add_to_cart_text1} ${totalItems} ${add_to_cart_text2}${
        totalItems > 1 ? "" : ""
      } ${add_to_cart_text3}`;
    }

    button.classList.add("active");
    button.classList.remove("disabled");
    button.innerHTML = totalString; // Update the button text with the formatted price
  } else {
    button.textContent = "Select Options";
    button.classList.remove("active");
    button.classList.add("disabled");
  }
}
